import React from "react";
import MainButton from "../button/MainButton";

export interface ErrorDisplayProps {
  error?: string;
  message?: string;
  onRetry?: () => void;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, message, onRetry }) => {
  const displayText = message || error;

  return (
    <div className="flex flex-col items-center w-full gap-6">
      {/* <span className="font-bold text-center capitalize text-english-vermillion-300">{error}</span> */}
      <span className="font-bold text-center text-closed-shutter-300">{displayText ? `Error: ${displayText}` : "An error occurred"}</span>
      {onRetry && <MainButton onClick={onRetry}>Try Again</MainButton>}
    </div>
  );
};

export default ErrorDisplay;
